import React from "react";
import { connect } from "react-redux";
import LoginForm from "../components/LoginForm";

class Login extends React.Component {
  render() {
    return <LoginForm history={this.props.history} />;
  }
}

function mapStateToProps(reducer) {
  return {
    loading: reducer.session.loading,
  };
}

export default connect(mapStateToProps)(Login);
